import React, {PropTypes} from 'react'
import {Router} from 'react-router'
import {Provider} from 'react-redux'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import customTheme from 'themes/custom'
import getMuiTheme from 'material-ui/styles/getMuiTheme'
import {history} from 'main'
import config from 'config'
import _ from 'lodash'

const muiTheme = getMuiTheme(customTheme)

class AppContainer extends React.Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    routes: PropTypes.object.isRequired,
    routerKey: PropTypes.number,
    store: PropTypes.object.isRequired
  }
  componentDidMount() {
    console.log("this.prosss - AppContainer",this.props)
    // Handle navigate request from iframe (casa-web-app)
    window.addEventListener('message', function(event) {
      if (event.origin !== config.casaWebAppUrl && event.origin !== config.ruleUiUrl) {
        return
      }
      const navigateTo = _.get(event, 'data.navigateTo')
      if (navigateTo) {
        history.push(navigateTo)
      }
    })
  }

  render() {
    const {history, routes, routerKey, store, keycloak} = this.props
    return (
      // <keyCloakContext.Provider value={keycloak.token}>
        <Provider store={store}>
          <MuiThemeProvider muiTheme={muiTheme}>
            <div style={{height: '100%'}} >
              <Router history={history} children={routes} key={routerKey} keycloak={keycloak} />
            </div>
          </MuiThemeProvider>
        </Provider>
      // </keyCloakContext.Provider>

    )
  }
}

export default AppContainer



// WEBPACK FOOTER //
// ./src/containers/AppContainer.js